// extracted by mini-css-extract-plugin
export default {"Section":"Section_Section__I8JaI","SectionHeader":"Section_SectionHeader__oAG8F","SectionBody":"Section_SectionBody__VzJCx"};